<template>
  <div id="Drivers">
    <SovecoNavBar />
    <div class="columns is-variable is-0">
      <div class="column is-narrow">
        <div class="drivers_top_box">AUTISTI</div>
        <VueScrollTable
          :options="driversOpts"
          :columns="driversCols"
          :rows="driversRows"
        />
        <div class="drivers_bot_box columns">
          <div class="column">
            <figure class="image is-32x32 is-center">
              <img
                title="Rimozione autista"
                :class="[isEmptyObject(driverSel) ? 'greyed' : '', 'buttonimg']"
                src="images/trash-icon.png"
                @click="doDeleteDriver"
              />
            </figure>
          </div>
          <div class="column">
            <figure class="image is-32x32 is-center">
              <img
                title="Aggiungi autista"
                class="buttonimg"
                src="images/add_driver.png"
                @click="createDriver"
              />
            </figure>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns is-variable is-0">
          <div class="column">
            <div class="drivers_scheda_top_box">
              Scheda Autista :
              <span class="drivers_scheda_top_box evidencewrite">
                {{ messageScheda }}
              </span>
            </div>
            <div id="DR002">
              <div class="drivers_scheda_box">
                <div class="field">
                  <label class="label">Cognome</label>
                  <div class="control">
                    <input
                      v-model="driverSel.cognome"
                      class="input"
                      type="text"
                      placeholder="cognome"
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Nome</label>
                  <div class="control">
                    <input
                      v-model="driverSel.nome"
                      class="input"
                      type="text"
                      placeholder="nome"
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Nick</label>
                  <div class="control">
                    <input
                      v-model="driverSel.nick"
                      class="input"
                      type="text"
                      placeholder="nick"
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Card ID</label>
                  <div class="control">
                    <input
                      v-model="driverSel.cod_f"
                      class="input"
                      type="text"
                      placeholder="card id"
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Codice Conducente</label>
                  <div class="control">
                    <input
                      v-model="driverSel.fax_1"
                      class="input"
                      type="text"
                      placeholder="codice conducente"
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Telefono 1</label>
                  <div class="control">
                    <input
                      v-model="driverSel.phone_1"
                      class="input"
                      type="text"
                      placeholder="telefono 1"
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">Telefono 2</label>
                  <div class="control">
                    <input
                      v-model="driverSel.phone_2"
                      class="input"
                      type="text"
                      placeholder="telefono 2"
                    />
                  </div>
                </div>

                <div class="field">
                  <label class="label">e-mail 1</label>
                  <div class="control">
                    <input
                      v-model="driverSel.email_1"
                      class="input"
                      type="text"
                      placeholder="email 1"
                    />
                  </div>
                </div>
                <div class="field">
                  <label class="label">e-mail 2</label>
                  <div class="control">
                    <input
                      v-model="driverSel.email_2"
                      class="input"
                      type="text"
                      placeholder="email 2"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="drivers_scheda_bot_box columns" />
          </div>
          <div class="column">
            <div class="drivers_scheda_top_box evidencewrite">-</div>
            <div id="DR003" class="drivers_scheda_box">
              <div class="field">
                <label class="label">Note</label>
                <div class="control">
                  <textarea
                    v-model="driverSel.note_driver"
                    class="textarea"
                    placeholder="note"
                  />
                </div>
              </div>
            </div>
            <div class="drivers_scheda_bot_box columns">
              <div class="column has-text-centered">
                <span class="button is-danger buttonsize" @click="cancelEntry"
                  >Annulla</span
                >
              </div>
              <div class="column has-text-centered">
                <span class="button is-success buttonsize" @click="saveEntry"
                  >Salva</span
                >
              </div>
            </div>
          </div>
          <div class="column">
            <div class="drivers_scheda_top_box">Veicoli assegnati</div>
            <VueScrollTable
              :options="logOpts"
              :columns="logCols"
              :rows="logRows"
            />
            <div class="drivers_bot_box columns">
              <div class="column" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import VueScrollTable from './reusable/VueScrollTable.vue'
export default {
  name: 'Drivers',
  components: {
    VueScrollTable,
  },
  mixins: [UtilityMixin],
  data() {
    return {
      api_server: '',
      auth: null,
      prefs: null,
      messageScheda: 'Selezionare un autista',
      windowHeight: 0,
      logRows: [],
      logOpts: {
        id: 'DRL02',
        isResizeable: false,
        isSelectable: false,
        cssContainer: 'log_drivers_list_container',
        cssHeader: 'log_drivers_list_header',
        cssBody: 'log_drivers_list',
        cssRows: 'log_drivers_list',
        order_col: 'check_in',
      },
      logCols: [
        {
          id: 'date_ope',
          visible: true,
          f_type: '*',
          title: 'Data',
          width: 150,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
        // {
        //   id: 'check_out',
        //   visible: true,
        //   f_type: '*',
        //   title: 'al',
        //   width: 150,
        //   alignment_th: '',
        //   alignment_td: '',
        //   elastic: true,
        //   filter: '',
        //   order: 1,
        //   image: false,
        // },
        {
          id: 'targa',
          visible: true,
          f_type: '*',
          title: 'Targa',
          width: 100,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'ope',
          visible: true,
          f_type: '*',
          title: 'Operazione',
          width: 100,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
      ],
      driversRows: [],
      driverSel: {},
      deleteAlert: true,
      driversOpts: {
        id: 'DR001',
        isResizeable: false,
        isSelectable: true,
        cssContainer: 'drivers_list_container',
        cssHeader: 'drivers_list_header',
        cssBody: 'drivers_list',
        cssRows: 'drivers_list',
        order_col: 'nick',
      },
      driversCols: [
        {
          id: 'cognome',
          visible: true,
          f_type: '*',
          title: 'Cognome',
          width: 100,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'nome',
          visible: true,
          f_type: '*',
          title: 'Nome',
          width: 100,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'cod_f',
          visible: true,
          f_type: '*',
          title: 'Card ID',
          width: 100,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
      ],
    }
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    ServiceBus.setApi(vm.api_server)
    ServiceBus.setAuth(vm.auth)
    if (vm.auth === null) {
      vm.$router.push({
        path: 'login',
      })
    }
    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', vm.getWindowHeight)
      vm.getWindowHeight()
      vm.doGetDriver()
    })
  },

  methods: {
    findDriver(cod_vehicle) {
      let vm = this
      if (vm.driversRows !== null || vm.driversRows.length > 0) {
        let obj = vm.driversRows.find((o) => o.cod_vehicle === cod_vehicle)
        if (obj !== undefined || obj !== null) {
          let idx = vm.driversRows.findIndex(
            (o) => o.cod_vehicle === cod_vehicle
          )
          obj.idx = idx
          return obj
        }
      }
      return null
    },
    clearSel() {
      const vm = this
      vm.driverSel = {}
      vm.driverSel.id = -1
      vm.driverSel.cod_f = ''
      vm.driverSel.cod_user = (' ' + vm.auth.cod).slice(1)
      vm.driverSel.cod_vehicle = ''
      vm.driverSel.cognome = ''
      vm.driverSel.nome = ''
      vm.driverSel.nick = ''
      vm.driverSel.email_1 = ''
      vm.driverSel.email_2 = ''
      vm.driverSel.phone_1 = ''
      vm.driverSel.phone_2 = ''
      vm.driverSel.fax_1 = ''
      vm.driverSel.note_driver = ''
    },
    createDriver() {
      const vm = this
      vm.messageScheda = 'Inserimento nuovo autista'
      vm.clearSel()
      vm.driverSel.cod_user = (' ' + vm.auth.cod).slice(1)
    },
    doDeleteDriver() {
      const vm = this
      if (!vm.isEmptyObject(vm.driverSel)) {
        let str
        if (vm.logRows.length > 0) {
          str =
            "Confermare la rimozione dell'autista <br>" +
            vm.driverSel.nome +
            ' ' +
            vm.driverSel.cognome +
            ' / ' +
            vm.driverSel.nick +
            "<br>L'autista nel passato è stato collegato a uno o più veicoli quindi il suo nominativo verrà solo dissociato dalla vostra Società, ma comparirà nei log dei veicoli"
        } else {
          str =
            "Confermare la rimozione dell'autista <br>" +
            vm.driverSel.nome +
            ' ' +
            vm.driverSel.cognome +
            ' / ' +
            vm.driverSel.nick
        }
        vm.$dialog
          .confirm(str)
          .then(function () {
            if (vm.logRows.length > 0) {
              vm.driverSel.cod_user = ''
              vm.saveEntry()
            } else {
              vm.deleteDriver()
            }
          })
          .catch(function () {})
      }
    },
    cancelEntry() {
      const vm = this
      vm.messageScheda = 'Selezionare un autista'
      ServiceBus.$emit('deselect')
      vm.clearSel()
    },

    async deleteDriver() {
      const vm = this
      let success = await ServiceBus._deleteDriver(vm.driverSel)
      if (success) {
        vm.$dialog
          .alert('Rimosso autista')
          .then(function () {})
          .catch(function () {})
        vm.cancelEntry()
        await vm.doGetDriver()
      }
    },

    async saveEntry() {
      const vm = this
      let success

      if (
        vm.driverSel.nome === '' &&
        vm.driverSel.cognome === '' &&
        vm.driverSel.nick === ''
      ) {
        vm.$dialog
          .alert(
            'Non é possibile creare un autista senza nessun nome identificativo'
          )
          .then(function () {})
          .catch(function () {})
        return
      }
      if (parseInt(vm.driverSel.id) < 0) {
        success = await ServiceBus._insertDriver(vm.driverSel)
        if (success.indexOf('error') < 0) {
          vm.$dialog
            .alert('Inserito autista')
            .then(function () {
              vm.cancelEntry()
            })
            .catch(function () {
              vm.cancelEntry()
            })
          vm.doGetDriver()
        } else {
          let mssg
          if (success.indexOf('id_unique') >= 0) {
            mssg = 'Errore: nome già presente in archivio'
          } else {
            mssg = 'Errore: controlla i dati inseriti'
          }
          vm.$dialog
            .alert(mssg)
            .then(function () {})
            .catch(function () {})
        }
      } else {
        success = await ServiceBus._updateDriver(vm.driverSel)
        if (success) {
          vm.$dialog
          vm.$dialog
            .alert('Modifiche registrate')
            .then(function () {
              vm.cancelEntry()
            })
            .catch(function () {
              vm.cancelEntry()
            })
        }
      }
    },
    colClick(id, col, item) {
      const vm = this
      vm.driverSel = item
      vm.messageScheda =
        vm.driverSel.cognome +
        ' ' +
        vm.driverSel.nome +
        ' / ' +
        vm.driverSel.nick
      vm.doGetLog()
    },

    async doGetDriver() {
      const vm = this
      const rdata = await ServiceBus._getDrivers()
      if (rdata.length > 0) {
        vm.driversRows = rdata
        if (!vm.isEmptyObject(vm.$route.params)) {
          let item = vm.findDriver(vm.$route.params.data)
          if (item !== null) {
            setTimeout(function () {
              vm.driverSel = item
              vm.messageScheda =
                vm.driverSel.cognome +
                ' ' +
                vm.driverSel.nome +
                ' / ' +
                vm.driverSel.nick
              vm.doGetLog()
              ServiceBus.$emit('select', item)
              ServiceBus.$emit('scroll', item.idx, 'DR001')
            }, 1000)
          }
        }
      }
    },
    async doGetLog() {
      const vm = this
      const pre = await vm.doGetLogPre()
      const post = await vm.doGetLogPost()
      vm.logRows = [...pre, ...post]

      vm.logRows.forEach((element) => {
        if (element.cod_vehicle_post === '') {
          element.ope = 'RIMOSSO'
        } else {
          element.ope = 'ASSEGNATO'
        }
      })
      vm.logRows.sort((a, b) => {
        if (a.date_ope < b.date_ope) return 1
        if (a.date_ope > b.date_ope) return -1
        if (a.ope > b.ope) return 1
        if (a.ope < b.ope) return -1
        return 0
      })
      console.log(vm.logRows)
    },

    async doGetLogPost() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server + 'get_driver_log_post/' + vm.driverSel.id_unique,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
      return []
    },
    async doGetLogPre() {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server + 'get_driver_log_pre/' + vm.driverSel.id_unique,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          return response.data
        }
      } catch (e) {
        console.log('error ' + e)
      }
      return []
    },
    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight
      document
        .getElementById(vm.driversOpts.id + 'bw')
        .setAttribute('style', 'height:' + (vm.windowHeight - 224) + 'px')
      document
        .getElementById(vm.logOpts.id + 'bw')
        .setAttribute('style', 'height:' + (vm.windowHeight - 224) + 'px')
      document
        .getElementById('DR002')
        .setAttribute('style', 'height:' + (vm.windowHeight - 190) + 'px')
      document
        .getElementById('DR003')
        .setAttribute('style', 'height:' + (vm.windowHeight - 190) + 'px')
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
    },
  },
}
</script>
